export default "__VITE_ASSET__DUVRFpHE__"